/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('widget', {
    templateUrl: '/templates/zenclerk_s/directives/dashboard/widget.html',
    transclude: {
      title: '?widgetTitle',
      content: 'widgetContent'
    },
    controllerAs: 'vm',
    controller: function() {
    // variables

    // actions

      this.$onInit = () => {
      };
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/widget.js